/** Friendly order labels without adding a catalog request to account pages. */
const OFFERING_NAMES: Readonly<Record<string, string>> = {
  // Canonical IDs from checkout/customer offerings and RAC purchase links.
  'ms-commercial-ra': 'Mississippi Registered Agent',
  'la-ra-annual': 'Louisiana Registered Agent',
  'al-ra-annual': 'Alabama Registered Agent',
  'ms-ra-annual': 'Mississippi Registered Agent',
  // Preserve the names used by legacy orders.
  'la-commercial-ra': 'Louisiana Registered Agent',
  'al-commercial-ra': 'Alabama Registered Agent',
  'ra-la-annual': 'Louisiana Registered Agent (Annual)',
  'ra-ms-annual': 'Mississippi Registered Agent (Annual)',
  'ra-al-annual': 'Alabama Registered Agent (Annual)',
};

/** Keep display names intact; turn unknown offering IDs into readable labels. */
export function formatServiceName(value: unknown): string | undefined {
  if (typeof value !== 'string' || !value.trim()) return undefined;
  const name = value.trim();
  const key = name.toLowerCase();
  if (Object.prototype.hasOwnProperty.call(OFFERING_NAMES, key)) return OFFERING_NAMES[key];
  if (!/^[a-z0-9]+(?:[-_][a-z0-9]+)+$/i.test(name)) return name;
  return name
    .split(/[-_]/)
    .map(word => {
      if (['ra', 'llc', 'ein'].includes(word.toLowerCase())) return word.toUpperCase();
      return word[0]!.toUpperCase() + word.slice(1).toLowerCase();
    })
    .join(' ');
}
